module.exports = __webpack_public_path__ + "static/media/star4.7b86a73f.svg";